/* Gr8Nes homepage sections: sliders, product tabs, countdown, add to cart. Safe to load more than once. */
(function () {
  if (window.Gr8) return;

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  /* ---------- Sliders: [data-gr8-slider] > [data-gr8-track], [data-gr8-dots], [data-gr8-prev]/[data-gr8-next], [data-gr8-controls] */
  function initSlider(wrap) {
    if (wrap.__gr8) return wrap.__gr8;
    var track = wrap.querySelector('[data-gr8-track]');
    var dots = wrap.querySelector('[data-gr8-dots]');
    var controls = wrap.querySelector('[data-gr8-controls]');
    if (!track || !dots) return null;
    var on = dots.getAttribute('data-on') || '#f47044';
    var off = dots.getAttribute('data-off') || 'rgba(0,0,0,0.25)';
    var label = dots.getAttribute('data-label') || 'Go to slide ';
    var pages = 0, page = 0;

    function count() {
      return track.clientWidth ? Math.max(1, Math.ceil((track.scrollWidth - 8) / track.clientWidth)) : 1;
    }
    function current() {
      var max = track.scrollWidth - track.clientWidth;
      return max <= 0 ? 0 : Math.round((track.scrollLeft / max) * (pages - 1));
    }
    function go(p) {
      if (p < 0) p = pages - 1;
      if (p > pages - 1) p = 0;
      var max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: pages > 1 ? (max * p) / (pages - 1) : 0, behavior: 'smooth' });
    }
    function render() {
      var n = count();
      if (n !== pages) {
        pages = n;
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', label + (i + 1));
            b.addEventListener('click', function () { go(i); });
            dots.appendChild(b);
          })(i);
        }
      }
      page = Math.min(current(), pages - 1);
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.style.background = i === page ? on : off;
        b.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
      dots.hidden = pages < 2;
      if (controls) controls.hidden = pages < 2;
    }
    track.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
    each(wrap, '[data-gr8-prev]', function (b) { b.addEventListener('click', function () { go(page - 1); }); });
    each(wrap, '[data-gr8-next]', function (b) { b.addEventListener('click', function () { go(page + 1); }); });
    render();
    wrap.__gr8 = { render: render };
    return wrap.__gr8;
  }

  /* ---------- Product tabs: [data-gr8-tabs] with [data-gr8-tab=key] buttons and [data-gr8-panel=key] panels */
  var tabRoots = [];
  function pick(root, key, scroll) {
    var found = false;
    each(root, '[data-gr8-tab]', function (b) {
      var hit = b.getAttribute('data-gr8-tab') === key;
      if (hit) found = true;
      b.setAttribute('aria-selected', hit ? 'true' : 'false');
    });
    if (!found) return false;
    each(root, '[data-gr8-panel]', function (p) {
      var hit = p.getAttribute('data-gr8-panel') === key;
      p.setAttribute('data-on', hit ? 'true' : 'false');
      if (hit) {
        var s = p.querySelector('[data-gr8-slider]');
        if (s && s.__gr8) s.__gr8.render();
      }
    });
    if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }
  function initTabs(root) {
    if (root.__gr8tabs) return;
    root.__gr8tabs = true;
    tabRoots.push(root);
    each(root, '[data-gr8-tab]', function (b) {
      b.addEventListener('click', function () { pick(root, b.getAttribute('data-gr8-tab'), false); });
    });
    var hash = (location.hash || '').slice(1);
    if (hash) pick(root, hash, false);
  }
  /* Links like <a href="#car"> anywhere on the page open that product tab */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var key = a.getAttribute('href').slice(1);
    for (var i = 0; i < tabRoots.length; i++) {
      if (pick(tabRoots[i], key, true)) { e.preventDefault(); return; }
    }
  });

  /* ---------- Countdown: [data-gr8-days][data-date="YYYY-MM-DD"] */
  function initCountdown(el) {
    var parts = (el.getAttribute('data-date') || '').split('-');
    if (parts.length !== 3) return;
    var target = new Date(+parts[0], +parts[1] - 1, +parts[2], 16, 0, 0);
    el.textContent = Math.max(0, Math.ceil((target - new Date()) / 86400000));
  }

  /* ---------- Add to cart: form[data-gr8-atc]. Uses the theme's cart drawer when it exposes the standard API, otherwise goes to /cart. */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function initAtc(form) {
    if (form.__gr8) return;
    form.__gr8 = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || 'Adding…'; }
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var data = new FormData(form);
      var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
      if (canRender) {
        data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        data.append('sections_url', window.location.pathname);
      }
      fetch(cartRoot() + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
          if (canRender) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
          } else if (document.getElementById('CartDrawer') && window.theme && theme.settings && theme.settings.cartType === 'drawer') {
            /* Gr8Nes Mara theme: theme.CartDrawer rebuilds and opens on this event */
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res, addToCartBtn: btn } }));
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.location.href = cartRoot() + 'cart';
          }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          var msg = form.parentNode.querySelector('.gr8-buy__error');
          if (!msg) { msg = document.createElement('p'); msg.className = 'gr8-buy__error'; msg.setAttribute('role', 'alert'); msg.style.cssText = 'margin-top:8px;font-size:14px;color:#ffb39b'; form.parentNode.appendChild(msg); }
          msg.textContent = err.message;
        });
    });
  }

  function init(scope) {
    scope = scope || document;
    each(scope, '[data-gr8-slider]', initSlider);
    each(scope, '[data-gr8-tabs]', initTabs);
    each(scope, '[data-gr8-days]', initCountdown);
    each(scope, 'form[data-gr8-atc]', initAtc);
  }

  window.Gr8 = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-gr8-panel]');
    var root = panel && panel.closest('[data-gr8-tabs]');
    if (root) pick(root, panel.getAttribute('data-gr8-panel'), false);
  });
})();
